<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Range') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-6">  
          <div class="form-group">
            <label for="allow" class="mimic-flex-row"><input type="radio" name="mode" id="allow" value="allow" v-model="range.mode" /> {{ _('Allow reservations') }}</label>
            <label for="deny" class="mimic-flex-row"><input type="radio" name="mode" id="deny" value="deny" v-model="range.mode" /> {{ _('Prevent reservations') }}</label>
            <label for="denyswitch" class="mimic-flex-row"><input type="radio" name="mode" id="denyswitch" value="denyswitch" v-model="range.mode" /> {{ _('Prevent reservation start/end') }}</label>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-inline">
            <div class="form-group">
              <label class="radiolabel mimic-flex-row">
                <input type="radio" name="dayrange" class="form-control inlineradio" id="allWeek" :value="0" v-model="dayRange" /> {{ _('Every weekday') }}
              </label>
            </div>
            <div class="flex-row">
              <input type="radio" name="dayrange" class="form-control inlineradio" id="dayRange" :value="1" v-model="dayRange" />
              <div class="form-group">
                <div class="input-group">
                  <div class="btn-group daybuttons" id="dayRangeButtons">
                    <label :class="'btn btn-sm ' + (weekdays.includes('1') ? 'btn-success' : 'btn-default')" data-value="1">
                      <input type="checkbox" autocomplete="off" v-model="weekdays" value="1" /> {{ _('mo') }}
                    </label> 
                    <label :class="'btn btn-sm ' + (weekdays.includes('2') ? 'btn-success' : 'btn-default')" data-value="2">
                      <input type="checkbox" autocomplete="off" v-model="weekdays" value="2" /> {{ _('tu') }}
                    </label> 
                    <label :class="'btn btn-sm ' + (weekdays.includes('3') ? 'btn-success' : 'btn-default')" data-value="3">
                      <input type="checkbox" autocomplete="off" v-model="weekdays" value="3" /> {{ _('we') }}
                    </label> 
                    <label :class="'btn btn-sm ' + (weekdays.includes('4') ? 'btn-success' : 'btn-default')" data-value="4">
                      <input type="checkbox" autocomplete="off" v-model="weekdays" value="4" /> {{ _('th') }}
                    </label> 
                    <label :class="'btn btn-sm ' + (weekdays.includes('5') ? 'btn-success' : 'btn-default')" data-value="5">
                      <input type="checkbox" autocomplete="off" v-model="weekdays" value="5" /> {{ _('fr') }}
                    </label> 
                    <label :class="'btn btn-sm ' + (weekdays.includes('6') ? 'btn-success' : 'btn-default')" data-value="6">
                      <input type="checkbox" autocomplete="off" v-model="weekdays" value="6" /> {{ _('sa') }}
                    </label> 
                    <label :class="'btn btn-sm ' + (weekdays.includes('7') ? 'btn-success' : 'btn-default')" data-value="7">
                      <input type="checkbox" autocomplete="off" v-model="weekdays" value="7" /> {{ _('su') }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-md-6">
          <div class="form-inline">
            <label class="radiolabel mimic-flex-row">
              <input type="radio" name="daterange" class="form-control inlineradio" id="allYear" :value="0" checked="checked" v-model="dateRange" /> {{ _('All year') }}
            </label>
            <div class="date-range-row">
              <input type="radio" name="daterange" class="form-control inlineradio" id="dateRange" :value="1" v-model="dateRange" />
              <DatePicker v-model="dateStart" :max-date="dateEnd" :shortLocale="shortLocale" :staticInput="true" :placeholder="_('Select start date')"></DatePicker>
              <p class="form-control-static">&nbsp;-&nbsp;</p>
              <DatePicker v-model="dateEnd" :min-date="dateStart" :shortLocale="shortLocale" :staticInput="true" :placeholder="_('Select end date')"></DatePicker>
            </div>
          </div> 
        </div>
        <div class="col-md-6">  
          <div class="form-inline">
            <label class="radiolabel mimic-flex-row">
              <input type="radio" name="timerange" class="form-control inlineradio" id="allDay" :value="0" checked="checked" v-model="timeRange" /> {{ _('All day') }}
            </label>
            <div class="date-range-row">
              <input type="radio" name="timerange" class="form-control inlineradio" id="timeRange" :value="1" v-model="timeRange" />
              <TimePicker :shortLocale="shortLocale" v-model="timeStart" :placeholder="_('Select start time')"/>
              <p class="form-control-static">&nbsp;-&nbsp;</p>
              <TimePicker :shortLocale="shortLocale" v-model="timeEnd" :placeholder="_('Select end time')"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 200px"></div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default hidden-xs" v-on:click="close"><i class="fa fa-close fa-fw"></i> {{ _('Close') }}</button>
      <button type="button" class="btn btn-success" v-on:click="save" :disabled="!isValid"><i class="fa fa-check fa-fw"></i>{{ _('Ok') }}</button>
      <button type="button" class="btn btn-danger pull-left" v-on:click="remove"><i class="fa fa-trash fa-fw"></i>{{ _('Delete') }}</button>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import { DatetimePicker } from '#components'

export default {
  data () {
    return {
      range: {},
    }
  },
  props: ['selectedRange'],
  computed: {
    ...mapGetters(['locale', 'dateFormat', 'timeFormat']),
    shortLocale () {
      return this.locale.split('_')[0]
    },
    dateStart: {
      get() {
        const datestart = this.range.datestart
        if (!datestart) {
          return null
        }
        return DateTime.fromFormat(datestart, 'd.M.yyyy', { zone: this.timezone }).toJSDate()
      },
      set(newValue) {
        if (newValue) {
          this.range.datestart = DateTime.fromJSDate(newValue, { zone: this.timezone }).toFormat('d.M.yyyy')
        } else {
          this.range.datestart = null
        }
      }
    },
    dateEnd: {
      get() {
        const dateend = this.range.dateend
        if (!dateend) {
          return null
        }
        return DateTime.fromFormat(dateend, 'd.M.yyyy', { zone: this.timezone }).toJSDate()
      },
      set(newValue) {
        if (newValue) {
          this.range.dateend = DateTime.fromJSDate(newValue, { zone: this.timezone }).toFormat('d.M.yyyy')
        } else {
          this.range.dateend = null
        }
      }
    },
    timeStart: {
      get() {
        const timestart = this.range.timestart
        const timeend = this.range.timeend
        if (!timestart || parseInt(timestart, 10) === 0) {
          if (parseInt(timestart, 10) === 0) {
            if (parseInt(timeend, 10) === 1440) {
              return null
            }
            return {
              hours: 0,
              minutes: 0,
              seconds: 0
            }
          }
          return null
        }
        return {
          hours: DateTime.fromFormat(this.convertToTime(timestart), 'H.mm').hour,
          minutes: DateTime.fromFormat(this.convertToTime(timestart), 'H.mm').minute,
          seconds: 0
        }
      },
      set(newValue) {
        if (!newValue) {
          this.range.timestart = 0
          return
        }
        this.range.timestart = this.convertToMinutes(DateTime.fromObject({
          hours: newValue.hours,
          minutes: newValue.minutes,
          seconds: 0
        }).toFormat('H.mm'))
      }
    },
    timeEnd: {
      get() {
        const timeend = this.range.timeend
        const timestart = this.range.timestart
        if (!timeend || parseInt(timeend, 10) === 1440) {
          if (parseInt(timeend, 10) === 1440) {
            if (parseInt(timestart, 10) === 0) {
              return null
            }
            return {
              hours: 0,
              minutes: 0,
              seconds: 0
            }
          }
          return null
        }
        return {
          hours: DateTime.fromFormat(this.convertToTime(timeend), 'H.mm').hour,
          minutes: DateTime.fromFormat(this.convertToTime(timeend), 'H.mm').minute,
          seconds: 0
        }
      },
      set(newValue) {
        if (!newValue) {
          this.range.timeend = 1440
          return
        }
        if (this.convertToMinutes(DateTime.fromJSDate(newValue, { zone: this.timezone }).toFormat('H.mm')) === 0) {
          this.range.timeend = 1440
        } else {
          this.range.timeend = this.convertToMinutes(DateTime.fromObject({
            hours: newValue.hours,
            minutes: newValue.minutes,
            seconds: 0
          }).toFormat('H.mm'))
        }
      }
    },
    dayRange: {
      get() {
        const weekdays = this.range.weekdays
        if (!weekdays || weekdays === '1,2,3,4,5,6,7') {
          return 0
        }
        return 1
      },
      set(newValue) {
        if (newValue === 0) {
          this.range.weekdays = '1,2,3,4,5,6,7'
        }
      }
    },
    dateRange: {
      get() {
        const datestart = this.range.datestart
        const dateend = this.range.dateend
        if (!datestart && !dateend) {
          return 0
        }
        return 1
      },
      set(newValue) {
        if (newValue === 0) {
          this.dateStart = null
          this.dateEnd = null
        }
      }
    },
    timeRange: {
      get() {
        const timestart = parseInt(this.range.timestart, 10)
        const timeend = parseInt(this.range.timeend, 10)
        if (!timestart && timeend === 1440) {
          return 0
        }
        return 1
      },
      set(newValue) {
        if (newValue === 0) {
          this.range.timestart = 0
          this.range.timeend = 1440
        }
      }
    },
    weekdays: {
      get() {
        const weekdays = this.range.weekdays
        if (!weekdays || weekdays === '1,2,3,4,5,6,7') {
          return []
        }
        return weekdays.split(',')
      },
      set(newValue) {
        this.range.weekdays = newValue.sort().join(',')
      }
    },
    isValid() {
      return true
    }
  },
  watch: {
    async weekdays (newValue, oldValue) {
      if (oldValue.length === 7 && newValue.length === 6) {
        const diff = oldValue.filter(x => !newValue.includes(x))
        await nextTick()
        this.weekdays = diff
      }
      if (oldValue.length === 1 && newValue.length === 0) {
        await nextTick()
        this.weekdays = [1, 2, 3, 4, 5, 6, 7]
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    save () {
      this.$emit('save', this.range)
    },
    remove () {
      this.$emit('remove', this.range)
    },
    convertToMinutes (time) {
      if (!time) {
        return 0
      }
      let extraDays = 0
      if (time.match(/\+/)) {
        let extraArr = String(time).split('+')
        time = extraArr[0]
        extraDays = parseInt(extraArr[1], 10)
      }
      let timeArr = String(time).split('.')
      let h = parseInt(timeArr[0], 10)
      let m = parseInt(timeArr[1], 10)
      h += extraDays * 24
      return h * 60 + m
    },
    convertToTime(minutes) {
      let minStr = (minutes % 60)
      if (minStr < 10) {
        minStr = '0' + minStr
      }
      return Math.floor(minutes / 60) + '.' + minStr
    }
  },
  components: {
    DatetimePicker
  },
  created() {
    if (this.selectedRange) {
      this.range = Object.assign({}, this.selectedRange)
    }
  }
}  

</script>

<style scoped>
.inlinedate {
  width: 110px !important;
}
.daybuttons input {
  display: none;
}
</style>
<style>
.bootstrap-datetimepicker-widget.dropdown-menu {
  /* width: 10em !important; */
}
</style>